export default __webpack_public_path__ + "images/pictograms/checkmark-circle.svg?09b2d7d3f13499413ab8f61ea93b3ed748c2dacc5bbbfc8862dcb6bfc864fc48";